<template>
	<div class="app-main-navigation height-100">
		<div class="upper-navigation overflow-hidden">
			<Row class="items-center justify-between header-container" :class="[useIsNotificationsPinned ? 'pt-4' : 'pt-[9px]']">
				<SIcon class="navigation-logo" name="ply-logo" :width="50" :height="22" />
				<CollapsedNavigationAccordionMenu v-if="!useIsNotificationsPinned" :nudgeRight="10" v-bind="inboxNavItem">
					<template #activator="{ value }">
						<AnemicButton :class="{ 'menu-open': value }" class="nav-btn pa-1 width-100" tile>
							<NavigationButton :collapsedMode="true" :item="inboxNavItem.collapsedModeNavButtonItem" />
						</AnemicButton>
					</template>
				</CollapsedNavigationAccordionMenu>
			</Row>
			<Row class="px-3 mb-2 mt-[15px]" :class="{ 'mt-2': !useIsNotificationsPinned }">
				<SpaceSelector />
			</Row>
			<div class="overflow-y-auto">
				<NavigationButtonsList :navItems="primaryNavItems" />
				<template v-if="useIsNotificationsPinned">
					<div class="navigation-separator mx-2 my-2 max-w-[30px]" />
					<NavigationAccordionsList class="px-2" :accordionsList="accordionsNavItems" />
				</template>
			</div>
		</div>
		<div class="bottom-navigation mt-2">
			<NavigationButtonsList :navItems="secondaryNavItems" />
			<UserMenu class="mx-2" />
		</div>
	</div>
</template>

<script>
import NavigationAccordionsList from './NavigationAccordionsList.vue';
import { SECONDARY_NAVIGATION_ITEMS, PRIMARY_NAVIGATION_ITEMS, getAccordionNavItems, getInboxNavItem } from './app-navigation.const';
import NavigationButtonsList from './common/NavigationButtonsList.vue';
import { useIsNotificationsPinned } from '@/store/modules/appLayout/getters';
import { userOnBoardingMetadata } from '@/store/modules/auth/getters';
import { fetchInboxes } from '@/store/modules/inboxes/actions';
import { useInboxes } from '@/store/modules/inboxes/getters';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import CollapsedNavigationAccordionMenu from '@/views/AppLayout/AppNavigation/CollapsedNavigationAccordionMenu.vue';
import UserMenu from '@/views/AppLayout/AppNavigation/UserMenu.vue';
import NavigationButton from '@/views/AppLayout/AppNavigation/common/NavigationButton.vue';
import SpaceSelector from '@/views/AppLayout/ManageAndCreate/SpaceSelector.vue';
export default {
	name: 'AppMainNavigation',
	components: {
		UserMenu,
		SpaceSelector,
		NavigationButtonsList,
		NavigationAccordionsList,
		CollapsedNavigationAccordionMenu,
		NavigationButton,
	},
	computed: {
		...mapGettersShorthand({ userOnBoardingMetadata, useInboxes, useIsNotificationsPinned }),
		accordionsNavItems() {
			return getAccordionNavItems({ useInboxesGetter: this.useInboxes, fetchInboxesAction: this.fetchInboxes });
		},
		inboxNavItem() {
			return getInboxNavItem({ useInboxesGetter: this.useInboxes, fetchInboxesAction: this.fetchInboxes });
		},
	},
	methods: {
		...mapActionsShorthand({ fetchInboxes }),
	},
	mounted() {
		this.accordionsNavItems.forEach(({ requiredAction }) => requiredAction());
	},
	data: () => ({
		primaryNavItems: PRIMARY_NAVIGATION_ITEMS,
		secondaryNavItems: SECONDARY_NAVIGATION_ITEMS,
	}),
};
</script>

<style lang="scss">
.app-main-navigation {
	display: flex;
	flex-direction: column;
	background: var(--bg-color);
	justify-content: space-between;
	border-radius: 0px 6px 6px 0px;

	&:hover {
		.suffix-component-container {
			//this class is in NavigationButtonsList.vue
			opacity: 1 !important;
			transition: 0.3s !important;
		}
	}

	.header-container {
		padding: 9px 15px 0px 22px;
	}

	.upper-navigation,
	.bottom-navigation {
		display: flex;
		flex-direction: column;
	}
}
.collapse-button {
	border-radius: 6px;
	padding: 0px !important;
}
.suffix-component-container {
	opacity: 0;
	transition: 0.2s;
}

.space-from-logo {
	top: 60px;
	margin-left: 28px;
	position: absolute;
}
.navigation-separator {
	border-bottom: 1px solid var(--border-color);
}
.nav-btn {
	$in-transition-time: 0.1s;
	$out-transition-time: 0.1s;
	height: 30px;
	color: #4d4c52;
	border-radius: 7px;
	text-decoration: none;
	font-weight: normal;
	background: var(--white) !important;
	&:hover {
		background: rgba(128, 128, 128, 0.1) !important;
	}
	&:before {
		position: absolute;
		top: 0;
		left: 0;
		content: '';
		height: 100%;
		width: 100%;
		border-radius: 6px;
		background: rgba(255, 255, 255, 0.2) !important;
		opacity: 0;
	}

	&.selected {
		background: #e7e8f9 !important;
		::v-deep {
			svg,
			path,
			rect,
			line {
				font-weight: 500;
				stroke: #7368d1;
			}
		}
		color: #7368d1;
		font-weight: normal;
		font-weight: 500;
		transition: $in-transition-time;

		&:before {
			opacity: 1;
			transition: $in-transition-time;
		}
	}
	&:hover {
		background: #e7e8f980;
		&:before {
			transition: $in-transition-time;
			opacity: 0.7;
		}
	}
	&:not(:hover),
	:not(.selected):not(:hover) {
		transition: $out-transition-time;

		&:before {
			transition: $out-transition-time;
		}
	}

	&:not(.selected) {
		transition: $out-transition-time;
		::v-deep {
			svg,
			path,
			rect,
			line {
				stroke: #6c7395;
			}
		}
	}

	&.menu-open {
		transition: $in-transition-time;
		background: #e9edf2 !important;
	}
}
</style>
